module.exports = __webpack_public_path__ + "static/media/tick-icon.6a6ee78e.svg";